// extracted by mini-css-extract-plugin
module.exports = {"KeenSliderWrapper":"ProductImageSlider_KeenSliderWrapper__m2ug0","IizWrapper":"ProductImageSlider_IizWrapper__1FTzy"};